import { useQuery } from '@tanstack/react-query';
import { useNotionOptionsApi } from '../components/ExpenseForm/useNotionOptionsApi';
import { useAuth } from '../contexts/AuthContext';

export const useDatabasesQuery = () => {
  const { getDatabasesFromParentPage } = useNotionOptionsApi();
  const { user } = useAuth();

  return useQuery({
    queryKey: ['databases', user?.telegramId],
    queryFn: async () => {
      const response = await getDatabasesFromParentPage();
      
      if (response.success && response.databases) {
        return response.databases.map(db => ({
          name: db.name,
          id: db.id
        }));
      }
      throw new Error(response.message || 'Failed to fetch databases');
    },
    enabled: !!user?.telegramId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    retry: 1,
  });
};

